import React from 'react';

import Tabs from 'src/views/components/Tabs';

import TabContent from '../components/TabContent';
import JiraServer from '../Legacy/JiraServer';

import AccountsMappingSummary from './AccountsMappingSummary';
import DebugLogs from './DebugLogs';
import Rules from './Rules';
import UsersMapping from './UsersMapping';


const ConfigWithAccountsMapping = () => (
  <div data-cy="accounts-mapping-config">
    <Tabs
      rememberTabKey="integration_jira_tabs_admin_main"
      analyticsEvent="settings_navigation"
      tabs={[
        { key: 'account_integration', label: 'Account Integration', content: <TabContent><AccountsMappingSummary/></TabContent> },
        { key: 'user_mapping', label: 'User mapping', content: <TabContent><UsersMapping/></TabContent> },
        { key: 'rules', label: 'Rules', content: <TabContent><Rules/></TabContent> },
        { key: 'debug', label: 'Debug logs', content: <TabContent><DebugLogs/></TabContent> },
        { key: 'legacy_integration', label: 'Legacy (add-on v3) integration', content: <TabContent><JiraServer/></TabContent> },
      ]}
    />
  </div>
);

export default ConfigWithAccountsMapping;
